import script from "./SocialShare.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialShare.vue?vue&type=script&setup=true&lang=js"

import "./SocialShare.vue?vue&type=style&index=0&id=40492173&lang=scss"

const __exports__ = script;

export default __exports__